import { TextField } from "@mui/material"
import { ChangeEvent, useMemo } from "react";
import { StringProperty } from "types/Property";
import { TooltipFormControl } from "./TooltipFormControl"

export type StringFormControlProps = {
    value?: string | number | Date | boolean
    property: StringProperty,
    onChange?: (newValue: string) => void
}

export function StringFormControl({ value, property, onChange }: StringFormControlProps) {
    const label = useMemo(() => {
        let label = property.displayName || property.name;
        if (property.readOnly)
            label += " (readonly)"
        return label;
    }, [property.name, property.readOnly, property.displayName])

    if(property.hidden){ return null; }

    return <TooltipFormControl property={property} >
        <TextField
            aria-label={`field-${property.name}`}
            id={`field-${property.name}`}
            data-testid={`field-${property.name}`}
            label={label}
            value={value || property.default || ''}
            onChange={handleChange}
            required={property.required}
            InputProps={{
                readOnly: property.readOnly,
            }}
            type="text"
            size='small'
            sx={{ width: '100%' }}
        />
    </TooltipFormControl>

    function handleChange(e: ChangeEvent<HTMLInputElement>) {
        if (property.readOnly) {
            console.warn(`Field ${property.name} is read-only and cannot be changed.`);
            return;
        }

        if (onChange)
            onChange(e.target.value);
    };
}